module.exports = __webpack_public_path__ + "static/media/swimming_icon.aff654c2.png";